<div class="full-height notranslate">
  <onset-cloze-test-ger-info [clozeTestStyleModel]="clozeTestStyleModel()" [cTestLogo]="cTestLogo()"
    [cTestButtonColor]="cTestButtonColor()" [mobileMode]="mobileMode()"></onset-cloze-test-ger-info>
</div>